module.exports = "<div>\r\n  <app-nav-menu></app-nav-menu>\r\n</div>\r\n"